export default "__VITE_ASSET__BBMEYvdQ__"